import React, { Component } from 'react';
import { RecommendAnExchangeHeading } from '../../Epics/Investments/Pages/RecommendFlow/styles';
import { FixedWidth } from '../Header/Component/ProductTour/style';
import BreadcrumbComponent from '../../CommonComponents/Breadcrumb/Breadcrumb';
import PageAccountSummary from '../PageSummary/PageAccountSummary/PageAccountSummary';
import PageSummary from './PageSummary/PageSummary';
import { getPrimaryAccount, getAccountData } from '../../utils/sessionUtil';
import SelectTabsContainer from './SelectTabsContainer/SelectTabsContainer';
import GenericStepper from './GenericStepper/GenericStepper';
import Preloader from '../Preloader/Preloader';
import ErrorPopup from '../ErrorPopup/ErrorPopup';
import { getFreezeFeaturesList } from '../../utils/freezeUtil';
import { SectionContent } from '../commonStyles';
import { ContentMessage, Types } from '../ContentMessages';
import PropTypes from 'prop-types';
import { isReadOnlyWithExchangeRole } from '../../Epics/Investments/Pages/RecommendAnExchangeNew/util';
import { isAllShareAllPool  } from '../../utils/commonUtil';
class RecommendFlow extends Component {
  constructor() {
    super();
    this.affixRef = React.createRef();
  }
  fundSummaryConfiguration = (showCurrentBalance = true, showAvailableBalance = true) => {
    const { accData } = this.props;
    const { accountNumber, accountName } = getPrimaryAccount();
    //Had to check undefined as 0 is a falsy value
    const showSummary = (!!accData.currentBalance || accData.currentBalance === 0)
      && (!!accData.availableBalance || accData.availableBalance === 0);
    const summaryConfig = [
      this.renderFundSummary({
        key: 'accountName',
        label: accountName,
        value: accountNumber
      })
    ];
    if (showCurrentBalance) {
      summaryConfig.push(
        this.renderFundSummary({
          key: 'currentBalance',
          label: 'Current Balance',
          value: parseFloat(accData.currentBalance).toFixed(2)
        })
      );
    }
    if (showAvailableBalance) {
      summaryConfig.push(
        this.renderFundSummary({
          key: 'availableBalance',
          label: 'Available Balance',
          value: parseFloat(accData.availableBalance).toFixed(2)
        })
      );
    }
    return showSummary ? summaryConfig : [<Preloader />];
  }

  renderFundSummary = obj => (
    <PageAccountSummary
      key={obj.key}
      label={obj.label}
      value={obj.value}
      dataName={obj.key}
    />
  );

  render = () => {
    const {
      activeTab,
      handleTabChange,
      children,
      pageHeader,
      breadcrumbRoutes,
      stepConfig,
      beforeMainContent,
      afterMainContent,
      editMode,
      disableSteppers,
      tabsConfig,
      history,
      accData,
      featureCode,
      grantAgreement = false,
      showCurrentBalance = true,
      showAvailableBalance = true,
      snagSection = false,
      balanceCheck = true,
      showSummary = true
    } = this.props;

    const { partyFreezes = [] } = getAccountData();
    const { role, freezes = [] } = getPrimaryAccount();
    const featureFrozen = getFreezeFeaturesList(partyFreezes, freezes).includes(featureCode);
    let isAllShareAllPoolStatus = isAllShareAllPool();
    if (featureFrozen) {
      return (
        <ErrorPopup
          title="Alert"
          primaryCta={() => history && history.push('/')}
          show
          data-test="alert_popup_one"
        >
          <SectionContent>Transactions for this account are frozen</SectionContent>
          <SectionContent>Contact us at <a id="anrContactUsTelFrozen" href={`tel:888-383-4483`}>888-383-4483</a> or <a href={`mailto:questions@vanguardcharitable.org`}>questions@vanguardcharitable.org</a></SectionContent>
        </ErrorPopup>
      );
    }
    
    // block the new recommend flow for Read Only account
    if (role && role.access === 'Read Only' && !(isReadOnlyWithExchangeRole() && featureCode === "RAE")) {
      return (
        <ErrorPopup
        title="Alert"
        primaryCta={() => history && history.push('/')}
        show
        >
          <SectionContent>{ `Your account is ${ isReadOnlyWithExchangeRole() ? 'read only + exchange' : 'read only' }` }</SectionContent>
          <SectionContent>Contact us at <a id="anrContactUsTel" href={`tel:888-383-4483`}>888-383-4483</a> or <a href={`mailto:questions@vanguardcharitable.org`}>questions@vanguardcharitable.org</a></SectionContent>
        </ErrorPopup>
      );
    }
    
    // block the new recommend flow for Read Only account
    if (balanceCheck && accData.availableBalance === 0) {
      return (
        <ErrorPopup
          title="Alert"
          primaryCta={() => history && history.push('/')}
          show
        >
          <SectionContent>You have insufficient balance to continue with this transaction.</SectionContent>
        </ErrorPopup>
      );
    }

    // block the new recommend flow when ASAP is active
    if (balanceCheck && isAllShareAllPoolStatus) {
      return (
        <ErrorPopup
          title="Alert"
          primaryCta={() => history && history.push('/')}
          show
        >
          <SectionContent>A grant has been recommended to close the account. Additional grant transactions cannot be submitted.</SectionContent>
        </ErrorPopup>
      );
    }

    return (
      <>
        <FixedWidth ref={this.affixRef}>
          {breadcrumbRoutes && <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes} />}
          {pageHeader &&
            (
              <RecommendAnExchangeHeading>
                <ContentMessage messageId="title" type={[Types.PAGE_TITLE_DESCRIPTION]} page={pageHeader} property="field_page_title" defaultMessage={<Preloader styling="btnLoader" />} />
              </RecommendAnExchangeHeading>
            )
          }
          {showSummary&&
          <PageSummary fundSummaryConfig={this.fundSummaryConfiguration(showCurrentBalance, showAvailableBalance)} />
          }
          {tabsConfig && (
            <SelectTabsContainer
              handleClick={activeKey => handleTabChange(activeKey)}
              config={tabsConfig()}
              activeTab={activeTab}
            />
          )}
          {beforeMainContent && beforeMainContent()}
          {stepConfig &&
            <GenericStepper
              affixRef={this.affixRef}
              disableSteppers={disableSteppers}
              hideSteps={editMode}
              stepConfig={stepConfig}
              snagSection={snagSection}
              grantAgreement={grantAgreement}
              featureCode={featureCode}
            />
          }
          {afterMainContent && afterMainContent()}
          {children}
        </FixedWidth>
      </>
    );
  }
}
RecommendFlow.propTypes = {
  accData: PropTypes.object,
  beforeMainContent: PropTypes.func,
  breadcrumbRoutes: PropTypes.array,
  featureCode: PropTypes.string,
  pageHeader: PropTypes.string,
  stepConfig: PropTypes.array
}

export default RecommendFlow;
